<template>
  <div class="mainCarousel">
    <b-carousel
      id="carousel-fade"
      :interval="4000"
      style="text-shadow: 0px 0px 2px #000"
      fade
      controls
    >
      <b-carousel-slide :img-src="Image[0]">
        <b-link to="/realizacje">
        <h2>Witamy Na Nowej Odsłonie Naszej Strony!</h2>
        <p>
          Dziękujemy za Państwa zainteresowanie i zapraszamy do zapoznanie się z
          nowymi zdjęciami, instrukcjami oraz naszą pełną ofertą!
        </p>
           </b-link>
      </b-carousel-slide>
            <b-carousel-slide :img-src="Image[2]">
        <b-link to="/gdzie-nas-znalezc">
          <h2>Rozwijamy Się Dla Państwa</h2>
          <p>
            Wieloletnia ciężka praca oraz zaufanie naszych klientów pozwoliło
            nam rozwinąć naszą siatkę sprzedaży i dystrybucji.
          </p>
        </b-link>
      </b-carousel-slide>
      <b-carousel-slide :img-src="Image[1]">
        <b-link to="/handmade">
          <h2>HandMade To Nie Tylko Pusty Slogan!</h2>
          <p>
            Drodzy Państwo, kupując nasze deski macie pewność, że każda z nich
            została wykonanie ręcznie, bez powtarzalnych, wytłaczanych wzorów.
          </p>
        </b-link>
      </b-carousel-slide>
      <b-carousel-slide :img-src="Image[3]">
        <b-link to="/aktualnosci">
          <h2>Wielki Powrót Klasyki!</h2>
          <p>
            Przypominamy, że każdy nasz kolor oraz wzór można zamówić w postaci
            jodełki klasycznej, francuskiej oraz węgierskiej.
          </p>
        </b-link>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Image: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    if (window.innerWidth > 600) {
      this.Image = [
        require("../../assets/carousel/4.jpg"),
        require("../../assets/carousel/1.jpg"),
        require("../../assets/carousel/3.jpg"),
        require("../../assets/carousel/2.jpg")
      ];
    } else {
      this.Image = [
        require("../../assets/carousel/s1.jpg"),
        require("../../assets/carousel/s2.jpg"),
        require("../../assets/carousel/s3.jpg"),
        require("../../assets/carousel/s4.jpg")
      ];
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>
<style scoped>
.mainCarousel p {
  font-size: 2vw;
  text-shadow: 2px 2px 4px #000000;
}
.mainCarousel h2 {
  text-shadow: 2px 2px 4px #000000;
  font-size: 4vw;
}
a h2,
a p {
  color: white;
}
a:hover h2,
a:hover p {
  color: white;
  text-decoration: underline;
}

@media (max-width: 1000px) {
  .mainCarousel p {
    font-size: 3vw;
  }
  .mainCarousel h2 {
    font-size: 4.5vw;
  }
}

@media (max-width: 600px) {
  .mainCarousel p {
    font-size: 5vw;
  }
  .mainCarousel h2 {
    font-size: 7vw;
  }
  .carousel-caption {
    top: 0%;
  }
}
</style>
